<script>
    const {classes, ...rest} = $$restProps;
</script>

<style lang="scss">
  .section {
    min-height: 100vh;
    display: flex;
  }

  @media screen and (max-width: 1024px) {
    .section {
      height: auto;
      min-height: auto;
    }
  }
</style>

<section {...rest} class="section">
    <slot></slot>
</section>
